export const CategoryList = [
  { id: 1, engName: "shoes", korName: "신발" },
  { id: 2, engName: "clothes", korName: "의류" },
  { id: 3, engName: "fashion", korName: "패션잡화" },
  { id: 4, engName: "life", korName: "라이프" },
  { id: 5, engName: "tech", korName: "테크" },
];
